import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { open } from 'store/modules/modal';
import { fetchPassInfoList, changePassInfo } from '../modules';
import PassKitInfo from '../components/PassKitInfo';
import { compose, lifecycle } from 'recompose';
import { reset } from 'redux-form';

import _ from 'lodash';

import { createPassInfo } from '../modules';

const mapStateToProps = state => {
  return {
    roles: _.get(state, 'auth.currentGroup.myRoles', 'default'),
    auth: state.auth,
    create: state.create,

    passInfoList: _.get(state, 'passinfo.passInfoList', null),
  };
};

const refreshTables = async (func, dispatch) => {
  await dispatch(func);
  await dispatch(fetchPassInfoList());
};

const mapDispatchToProps = dispatch => ({
  fetchPassInfoList() {
    dispatch(fetchPassInfoList());
  },
  onCancel() {
    refreshTables(reset('createPassKitInfoForm'), dispatch);
  },
  updatePassInfo(row, props) {
    props.change('id', row._id);
    props.change('template', row.template);
    props.change('token', row.token);
    props.change('subject', row.subject);
    props.change('message', row.message);
  },
});

const validate = values => {
  const errors = {};

  const requiredFields = ['template', 'token', 'subject', 'message'];

  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = 'Required';
    }
  });

  return errors;
};

const $reduxForm = reduxForm({
  form: 'createPassKitInfoForm',
  validate,

  onSubmit(passInfo, dispatch) {
    if (!_.isEmpty(passInfo) && passInfo) {
      if (passInfo.id && passInfo.id !== '') {
        refreshTables(changePassInfo(passInfo), dispatch);
      } else {
        refreshTables(createPassInfo(passInfo), dispatch);
      }

      dispatch(reset('createPassKitInfoForm'));
    } else {
      dispatch(reset('createPassKitInfoForm'));
    }
  },

  onSubmitSuccess(result, dispatch, props) {
    props.history.push('/Dashboard/passKitInfo');
  },

  onSubmitFail(formErrors, dispatch, submitError) {
    if (submitError) {
      dispatch(
        open({
          modalType: 'error',
          modalProps: {
            message: `PassKit Info could not be Saved. Detail: ${
              submitError.message
            }`,
          },
        })
      );
    }
  },
});

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  lifecycle({
    componentDidMount() {
      this.props.fetchPassInfoList();
    },
    componentDidUpdate() {},
  })
);

export default $reduxForm(enhance(PassKitInfo));
